module.exports = __webpack_public_path__ + "img/89.b08e1f35.webp";